import { render } from "./BenchmarkManagerEditor.vue?vue&type=template&id=27ee9279"
import script from "./BenchmarkManagerEditor.vue?vue&type=script&lang=js"
export * from "./BenchmarkManagerEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__